import { isNotNilOrEmpty } from '../../value/isNotNilOrEmpty';
import { typeOf } from '../../type/typeOf';
import { assign } from '../assign';
import { keys } from '../keys';
/**
 * Immutably sorts the object keys
 *
 * @category Object
 * @template {T} - The type of the original object
 * @param {T} obj - The original object
 * @returns {T}
 * @example
 * const obj = { hamster: true, frog: false, cow: false };
 * sortKeys(obj) //=> { cow: false, frog: false, hamster: true }
 * @docgen_example
 * const obj = { hamster: true, frog: false, cow: false };
 * sortKeys(obj);
 */
export var sortKeys = function (obj) {
    return isNotNilOrEmpty(obj) && typeOf(obj) === 'object'
        ? keys(obj).sort().reduce(function (accumulator, key) {
            var _a;
            return assign(accumulator, (_a = {}, _a[key] = obj[key], _a));
        }, {})
        : obj;
};
